import * as _ from 'lodash';
import axios from 'axios';

class Refund {

    getRefundPassage(filter) {
        return axios.post('/v2/financial/getRefundPassage', filter).then(res => {
            return res.data;
        });
    }
    getRefundPassageHist(refundPassageId) {
        return axios.get(`/v2/financial/getRefundPassageHist/${refundPassageId}`).then(t => t.data);
    }
    updateRefundPassage(request) {
        return axios.post('/v2/financial/updateRefundPassageStatus', request).then(t => t.data);
    }
    findPassagesAndRefunds(filter) {
        return axios.post('/v2/financial/transactionRefundInfo', filter).then(t => t.data);
    }
    exportRefundReport(filter) {
        let config = {
            responseType: "blob"
        };
        return axios.post('/v2/financial/exportRefundReport', filter, config).then(t => t.data);
    }
    exportRefundReport2(data) {
        return axios.post('/v2/financial/exportRefundReport2', data).then(t => t.data);
    }
    downloadRefundFile(request) {
        let config = {
            responseType: "blob"
        };
        return axios.post('v2/financial/downloadRefundFile', request, config).then(res => {
            return res.data;
        });
    }
    uploadRefundFiles(req) {
        return axios.post('/v2/financial/uploadRefundFiles', req).then(t => t.data);
    }
    createRefundPassageLote(req) {
        return axios.post(`/v2/financial/createRefundPassageLote`, req).then(r => r.data);
    }
    updateRefundPassageStatusLote(req) {
        return axios.post('/v2/financial/updateRefundPassageStatusLote', req).then(t => t.data);
    }
    createRefundPassage(request) {
        return axios.post(`/v2/financial/createRefundPassage`, request).then(r => r.data);
    }
    isRefundPassage(filter) {
        return axios.post('/v2/financial/isRefundPassage', filter).then(res => {
            return res.data;
        });
    }
    getRefusedDebit(transactionId) {
        return axios.get(`/v2/financial/getRefusedDebit/${transactionId}`).then(t => t.data);
    }

}

const instance = new Refund();
export default instance;



// WEBPACK FOOTER //
// ./src/services/refund-service.js